import API from './base';
import { getUrlToLKApi } from '../constants/api';
import { getToken } from '../helpers';

export default class PromocodesAPI extends API {
  async activate(code) {
    await this.post(getUrlToLKApi('promocode/activate'), { code }, getToken(), false);
  }
}
